<div class="migrations-container">
  <ziro-breadcrumbs>
    <ziro-breadcrumb-card-item [aboutCardId]="102"></ziro-breadcrumb-card-item>
  </ziro-breadcrumbs>

  @if (isLoading) {
    <ziro-loading-block></ziro-loading-block>
  } @else {
    <ziro-datatable
      [class]="'ziro-card'"
      [rowDataSource]="tableRows"
      [columns]="columns"
      [uniqueRowIdentifier]="'name'"
      [dataAutomation]="'migrations-cisco-hunt-lists-datatable'"
      [matchesSecondaryDataFn]="lineGroupMembershipSearch"
      [mainFilterPlaceholder]="'tkey;migrations.cisco.hunt_lists.list_view.table.filter.placeholder' | translate"
    ></ziro-datatable>
  }

  <ng-template #lineGroupsPopover>
    <div class="line-group-popover">
      <div class="mb-4">
        <strong>{{ 'tkey;migrations.cisco.hunt_lists.list_view.table.line_groups.popover.header' | translate }}</strong>
      </div>
      <div>
        @for (lineGroup of lineGroupsPopoverData; track lineGroup.lineGroupName) {
          <div class="d-flex mt-3 align-items-center gap-2">
            <span>
              <i
                class="{{
                  lineGroupDistributionIcon(lineGroup)
                }} small bg-info text-white line-group-popover-icon-padding rounded-circle"
              ></i>
            </span>
            <div class="d-flex flex-column line-group-popover-text align-items-start">
              <span class="line-group-popover-text__name">{{ lineGroup.lineGroupName }}</span>
              <span class="text-muted line-group-popover-text__algorithm">{{ lineGroup.distributionAlgorithm }}</span>
            </div>
          </div>
        }
      </div>
    </div>
  </ng-template>
</div>
